import axios from "axios";
import i18n from "../i18n";
import { AUTH_SERVICE_URL } from "./constant";
import { setLang } from "./utils";

export const SheetNames = {
    StageStatus: 'StageStatus',
    RequestType: 'RequestType',
    // AssetType: 'AssetType',
    DocumentTypes: 'DocumentTypes',
    Packaging: 'Packaging',
    InquiryCategory: 'InquiryCategory',
    AdditionalInfo: 'AdditionalInfo',
    AdditionalFields: 'AdditionalFields',
    Services: 'Services',
    Assets: 'Assets',
    // ClientDocumentTypes: 'ClientDocumentTypes',
    PortalGroup: 'PortalGroup',
}

const loadedLangMap = {}
export const getJsonLanguage = async (lngCode, portalId = 0) => {
    console.log(`getJsonLanguage ${lngCode}`)
    setLang(portalId, lngCode)
    if (loadedLangMap[lngCode]) {
        console.log(`The lang ${lngCode} already loaded`)
        i18n.changeLanguage(lngCode);
        return
    }
    loadedLangMap[lngCode] = true
    await axios({
        method: "GET",
        url: `${AUTH_SERVICE_URL}/translation/${lngCode}`
    }).then((response) => {
        const jsonData = response.data.data;
        if (Object.keys(jsonData).length > 0) {
            jsonData.Noti.VOC = JSON.parse(jsonData.Noti.VOC)
            jsonData.Noti.REPORT = JSON.parse(jsonData.Noti.REPORT)
            jsonData.Noti.REQUEST = JSON.parse(jsonData.Noti.REQUEST)
            i18n.addResourceBundle(lngCode, "translations", jsonData, true, true);
        }
    }).catch((e) => {
        console.log("ERROR", e);
        loadedLangMap[lngCode] = false
    }).finally(()=> {
        console.log(`changeLanguage ${lngCode}`)
        i18n.changeLanguage(lngCode);
    })
}

export const changeLanguage = (lngCode, portalId = 0) => {
    i18n.changeLanguage(lngCode);
    setLang(portalId, lngCode)
}


export const getMasterDataTranslation = async (lngCode, portalId = 0) => {
    loadedLangMap[lngCode] = true

    const loadCurrentLanguageMasterdata = async () => {
        try {
            const response = await axios({
                method: "GET",
                url: `${AUTH_SERVICE_URL}/translation/master-data/${lngCode}`
            });
            const jsonData = response.data.data;
            if (Object.keys(jsonData).length > 0) {
                i18n.addResourceBundle(lngCode, "translations", jsonData, true, true);
            }
        } catch (e) {
            console.log("ERROR loading current language masterdata", e);
            loadedLangMap[lngCode] = false;
        }
    };

    await loadCurrentLanguageMasterdata();

    i18n.changeLanguage(lngCode);
}

export const getPortalDataTranslation = async (lngCode, portalId = 0) => {
    loadedLangMap[lngCode] = true

    const loadCurrentLanguagePortalData = async () => {
        try {
            const response = await axios({
                method: "GET",
                url: `${AUTH_SERVICE_URL}/translation/portal-data/${lngCode}/${portalId}`
            });
            const jsonData = response.data.data;
            if (Object.keys(jsonData).length > 0) {
                i18n.addResourceBundle(lngCode, "translations", jsonData, true, true);
            }
        } catch (e) {
            console.log("ERROR loading current language portal data", e);
            loadedLangMap[lngCode] = false;
        }
    };

    await loadCurrentLanguagePortalData();

    i18n.changeLanguage(lngCode);
}

// export const translate = (value, sheetName, ) => {
//     const valueCamelCase = value.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
//     const valueRemoveSpace = valueCamelCase.replace(/ /g, '');
//     if (!value) return '';
//     const translation = i18n.t(`${sheetName}.${valueRemoveSpace}`);
//     // If translation is the same as the key (meaning no translation found), return original value
//     return (!translation || translation === '' || translation === `${sheetName}.${valueRemoveSpace}`) ? value : translation;
// }

export const translate = (value, sheetName, splitTranslation = false) => {
    if (!value) return '';
    value = value.toString();
    const valueCamelCase = value.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
    const valueRemoveSpace = valueCamelCase.replace(/ /g, '');
    const translation = i18n.t(`${sheetName}.${valueRemoveSpace}`);
    if (!translation || translation === '' || translation === `${sheetName}.${valueRemoveSpace}`) return value;

    if (translation.includes('#')) {
        const parts = translation.split('#');
        return splitTranslation ? (parts[1] ? parts[1].trim() : '') : (parts[0] ? parts[0].trim() : '');
    }
    return translation.trim();
};

export const getLanguage = () => {
    return i18n.language;
}